module.exports = __webpack_public_path__ + "static/media/fk.519e3de5.svg";